import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOpenXAgentContext } from '../../context/useOpenXAgentContext';
import { OpenXAgentMatchedDomainAppPanel } from '../MatchesDetails/MatchedDomainApp/OpenXAgentMatchedDomainAppPanel';
import { MOCK_MATCHED_DOMAIN_APP_PANEL } from '../MatchesDetails/MatchedDomainApp/utils/mocks';
import { OpenXAgentMatchedSegmentPanel } from '../MatchesDetails/MatchedSegment/OpenXAgentMatchedSegmentPanel';
import { MOCK_MATCHED_SEGMENT_PANEL } from '../MatchesDetails/MatchedSegment/utils/mocks';
import { OpenXAgentSaveAudienceDialog } from '../SaveAudience/OpenXAgentSaveAudienceDialog';
import { actionButtonSx, rootSx } from './OpenXAgentDealPromptView.styles';

// Empty state for the Deal Prompt chat column until the agent conversation is implemented.
// The buttons are preview entry points for the side panels the agent will open; their back buttons close the panel.
// "Open save audience popup" previews the Save your Audience dialog; audience/deal creation is not wired yet.
export const OpenXAgentDealPromptView = () => {
  const { t } = useTranslation();
  const { openSidePanel } = useOpenXAgentContext();
  const [isSaveAudienceOpen, setIsSaveAudienceOpen] = useState(false);

  const handleShowMatchedDomains = useCallback(
    () => openSidePanel({ component: <OpenXAgentMatchedDomainAppPanel {...MOCK_MATCHED_DOMAIN_APP_PANEL} /> }),
    [openSidePanel]
  );

  const handleShowMatchedSegments = useCallback(
    () => openSidePanel({ component: <OpenXAgentMatchedSegmentPanel {...MOCK_MATCHED_SEGMENT_PANEL} /> }),
    [openSidePanel]
  );

  const handleOpenSaveAudience = useCallback(() => setIsSaveAudienceOpen(true), []);
  const handleCloseSaveAudience = useCallback(() => setIsSaveAudienceOpen(false), []);
  const handleSaveAudience = useCallback(async () => {
    // Intentionally empty: save audience API integration is not wired yet.
  }, []);

  return (
    <Box data-test="openx-agent-deal-prompt-view" sx={rootSx}>
      <Typography sx={{ fontSize: 14, lineHeight: '20px', color: 'text.secondary', textAlign: 'center' }}>
        {t('Your Deal Prompt conversation will appear here.')}
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1 }}>
        <ButtonBase
          data-test="openx-agent-deal-prompt-show-matched-domains"
          onClick={handleShowMatchedDomains}
          sx={actionButtonSx}
        >
          {t('Show matched domains')}
        </ButtonBase>

        <ButtonBase
          data-test="openx-agent-deal-prompt-show-matched-segments"
          onClick={handleShowMatchedSegments}
          sx={actionButtonSx}
        >
          {t('Show matched segments')}
        </ButtonBase>

        <ButtonBase
          data-test="openx-agent-deal-prompt-create-deal-with-setup"
          onClick={handleOpenSaveAudience}
          sx={actionButtonSx}
        >
          {t('Open save audience popup')}
        </ButtonBase>
      </Box>

      <OpenXAgentSaveAudienceDialog
        open={isSaveAudienceOpen}
        onClose={handleCloseSaveAudience}
        onSubmit={handleSaveAudience}
      />
    </Box>
  );
};
